import { createMap, IDataLayer, IGenericPlan, setupLayerRelations } from "../omnia"

export interface HoldingLayers {
    roots: IDataLayer[]
    all: IDataLayer[]
}


export function updateCachedLayer(hl: HoldingLayers, layer: IDataLayer, plans: IGenericPlan[]) {

    if (!hl) {
        return
    }

    const layerId = layer.DataLayerId
    const newLayer = hl.all.every(l => l.DataLayerId !== layerId)

    if (newLayer) {

        hl.all = hl.all.concat(layer)

        if (!layer.ParentId) {
            hl.roots = hl.roots.concat(layer)
        }

    }
    else {

        function update(a: IDataLayer[]) {
            return a.map(l => l.DataLayerId === layerId ? layer : l)
        }

        hl.all = update(hl.all)
        hl.roots = update(hl.roots)

    }

    const relUpdates = [layer].concat(hl.all.filter(l => l.DataLayerId === layer.ParentId))

    setupLayerRelations(relUpdates, hl.all)

    updatePlans(hl, plans)

}


export function removeCachedLayers(hl: HoldingLayers, layerIds: number[], plans: IGenericPlan[]) {

    if (!hl) {
        return
    }

    const layerIdsSet = new Set(layerIds)

    function update(a: IDataLayer[]) {
        return a.filter(l => !layerIdsSet.has(l.DataLayerId))
    }

    hl.all = update(hl.all)
    hl.roots = update(hl.roots)

    setupLayerRelations(hl.all, hl.all)

    updatePlans(hl, plans)

}

function updatePlans(hl: HoldingLayers, plans: IGenericPlan[]) {

    const plansMap = createMap(plans, p => p.GenericPlanId)

    for (const l of hl.all) {
        l.GenericPlan = plansMap.get(l.GenericPlanId)
    }

}
